import styled from '@emotion/styled';
import MUIDivider from '@material-ui/core/Divider';

const Divider = styled(MUIDivider)`
  background-color: var(--color-divider);
`;

export default Divider;
